import { FC, useMemo } from "react";
import { useTaxonomyContext } from "../../../contexts/Taxonomy/TaxonomyContext";
import TreeSelect from "../TreeSelect/TreeSelect";
import { transformToTree } from "../TreeSelect/utils";

interface ProductCategoryInputProps {
  onProductCategorySelect: (productCategoryIds: string[]) => void;
  selectedItems: string[];
  id?: string;
  onClose?: () => void;
}

export const ProductCategoryInput: FC<ProductCategoryInputProps> = ({
  onProductCategorySelect,
  selectedItems = [],
  id = "product-category-input",
  onClose,
}) => {
  const { productCategories } = useTaxonomyContext();
  const productCategoriesWithParentId = useMemo(
    () =>
      productCategories.map((pc) => ({
        ...pc,
        parentId: pc.parentId || "0",
      })),
    [productCategories]
  );

  const allOptions = useMemo(
    () => transformToTree(productCategoriesWithParentId, (i) => `${i.name}`),
    [productCategoriesWithParentId]
  );

  return (
    <TreeSelect
      id={id}
      items={allOptions}
      selectedItems={selectedItems}
      onSelectItems={onProductCategorySelect}
      allExpanded
      onClose={onClose}
    />
  );
};
